import { Link, useRouterState } from "@tanstack/react-router";
import { cx } from "./ui";

export type NavItem = { href: string; label: string; icon: keyof typeof icons };

const icons = {
  home: "M3 11l9-8 9 8v9a1 1 0 01-1 1h-5v-6H9v6H4a1 1 0 01-1-1z",
  users: "M16 11a4 4 0 10-8 0 4 4 0 008 0zM4 21a8 8 0 0116 0",
  dumbbell: "M6 7v10M18 7v10M3 9v6M21 9v6M6 12h12",
  team: "M9 11a3 3 0 100-6 3 3 0 000 6zM17 11a3 3 0 100-6M3 20a6 6 0 0112 0M15 14a6 6 0 016 6",
  settings: "M12 15a3 3 0 100-6 3 3 0 000 6zM19 12a7 7 0 00-.1-1.2l2-1.6-2-3.4-2.4 1a7 7 0 00-2-1.2L14 3h-4l-.5 2.6a7 7 0 00-2 1.2l-2.4-1-2 3.4 2 1.6a7 7 0 000 2.4l-2 1.6 2 3.4 2.4-1a7 7 0 002 1.2L10 21h4l.5-2.6a7 7 0 002-1.2l2.4 1 2-3.4-2-1.6c.1-.4.1-.8.1-1.2z",
  chart: "M4 20V10M10 20V4M16 20v-7M22 20H2",
  calendar: "M4 6h16v14H4zM4 10h16M8 3v4M16 3v4",
  history: "M3 12a9 9 0 109-9 9 9 0 00-6.4 2.6L3 8M3 3v5h5M12 7v5l3 3",
  food: "M7 3v8a2 2 0 002 2v8M5 3v5a2 2 0 002 2M9 3v5a2 2 0 01-2 2M17 21V3c-2 1-3 4-3 7s1 4 3 4",
};

export function BottomNav({ items }: { items: NavItem[] }) {
  const path = useRouterState({ select: (s) => s.location.pathname });
  // The active workout screen has its own controls.
  if (path.endsWith("/log")) return null;
  return (
    <nav className="print:hidden fixed inset-x-0 bottom-0 z-20 border-t border-border bg-bg/95 pb-[env(safe-area-inset-bottom)] backdrop-blur">
      <ul className="mx-auto flex max-w-2xl">
        {items.map((it, i) => {
          const active =
            i === 0
              ? path === it.href
              : path.startsWith(it.href) || (it.href.endsWith("/series") && (path.includes("/exercises") || path.includes("/programs")));
          return (
            <li key={it.href} className="flex-1">
              <Link
                to={it.href}
                className={cx("flex flex-col items-center gap-1 py-2.5 text-[11px]", active ? "text-primary" : "text-muted")}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d={icons[it.icon]} />
                </svg>
                {it.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
